import { ApplicationConfig, provideAppInitializer, provideBrowserGlobalErrorListeners } from "@angular/core";
import { provideRouter } from "@angular/router";
import dxConfig from "devextreme/core/config";
import { provideHttpClient, withInterceptors, withXhr } from "@angular/common/http";

import { routes } from "./app.routes";
import { Environment } from "../environment";
import { AuthenticatedGuard } from "./pages/authenticated-guard";
import { UnauthenticatedGuard } from "./pages/unauthenticated-guard";
import { authInterceptor } from "./interceptors/auth.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAppInitializer(appInitializer),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor])),
    AuthenticatedGuard,
    UnauthenticatedGuard,
  ],
};

function appInitializer() {
  dxConfig({
    licenseKey: Environment.DxLicenseKey,
  });
}
